import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  FiShoppingCart,
  FiShoppingBag,
  FiBarChart2,
  FiTruck,
  FiUserCheck,
  FiUsers,
  FiAlertCircle,
  FiStar,
  FiCheckCircle,
} from "react-icons/fi";

const iconSize = 18;

// Permission-based actions (available to admin if they have the permission)
// permissionKey maps to the user's permissionObject keys
const permissionActions = [
  { label: "Orders", path: "/orders", icon: <FiShoppingCart size={iconSize} />, permissionKey: "DeliveryOrder" },
  { label: "Shopkeepers", path: "/Shopkeepers", icon: <FiShoppingBag size={iconSize} />, permissionKey: "Shopkeeper" },
  { label: "Delivery Charges", path: "/pricing/delivery-charges", icon: <FiTruck size={iconSize} />, permissionKey: "Pricing" },
  { label: "Seller Registrations", path: "/seller-registration", icon: <FiUserCheck size={iconSize} />, permissionKey: "RegistrationRequests" },
  { label: "Users", path: "/user", icon: <FiUsers size={iconSize} />, permissionKey: "User" },
  { label: "Alert Messages", path: "/alert-messages", icon: <FiAlertCircle size={iconSize} />, permissionKey: "AlertMessages" },
  { label: "Marketplace Expenses", path: "/marketplace-expenses", icon: <FiBarChart2 size={iconSize} />, permissionKey: "MarketplaceExpenses" },
  { label: "Listing Reviews", path: "/listing-reviews/approvals", icon: <FiStar size={iconSize} />, permissionKey: "ListingReviews" },
  { label: "Dummy Reviews", path: "/listing-reviews/dummy", icon: <FiCheckCircle size={iconSize} />, permissionKey: "ListingReviews" },
];

const QuickActions = () => {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const userType = user?.user_type;
  const permissions = user?.permissionObject;

  let actions;
  if (userType === "super-admin") {
    actions = permissionActions;
  } else {
    // Admin: only actions they have permissions for
    actions = permissionActions.filter(
      (a) => permissions && Number(permissions[a.permissionKey]) === 1
    );
  }

  if (actions.length === 0) return null;

  return (
    <div className="d-flex flex-wrap gap-2 mb-3">
      {actions.map((action) => (
        <button
          key={action.path}
          onClick={() => navigate(action.path)}
          className="d-inline-flex align-items-center gap-2 px-3 py-2 quick-action-btn"
        >
          <span className="quick-action-icon">{action.icon}</span>
          <span className="quick-action-label">{action.label}</span>
        </button>
      ))}
    </div>
  );
};

export default QuickActions;
